import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=b7969b92&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=b7969b92&prod&scoped=true&lang=css"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=b7969b92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7969b92",
  null
  
)

export default component.exports